import { createSelector } from 'reselect'
import { get } from 'lodash'
import { organizations as organizationsLayout } from 'constants/layout'
import { ORGANIZATIONS_BULK } from '../../../constants/enums'

const getOrganizations = state => get(state, 'api.organizations.list', [])

const getBulkType = state => get(state,
  `form.${organizationsLayout.bulkForm}.values.bulkType`,
  '')

export function mapForBulk(organizations, bulkType) {
  switch (bulkType) {
    case ORGANIZATIONS_BULK.assignLabels.id:
      return organizations.map(o => o.id)

    case ORGANIZATIONS_BULK.unassignLabels.id:
      return organizations.map(o => o.id)

    default:
      return []
  }
}

export default createSelector([getOrganizations, getBulkType],
  mapForBulk)
